import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MbExpandableTextModule } from '@am/moebius';
import { NgIf } from '@angular/common';

@Component({
    selector: 'card-info-detail-v2',
    templateUrl: './card-info-detail-v2.component.html',
    styleUrls: ['./card-info-detail-v2.component.scss'],
    standalone: true,
    imports: [NgIf, MbExpandableTextModule],
})
export class CardInfoDetailV2Component {
  viewLess = true;

  @Input() showButton: boolean;
  @Output() viewMoreLessEvent: EventEmitter<boolean> = new EventEmitter();

  onClickViewMore(viewLess) {
    this.viewLess = !viewLess;
    this.viewMoreLessEvent.emit(this.viewLess);
  }
}
